/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'Booking'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('booking'); // main translation loaded for booking
		$translatePartialLoader.addPart('bookingstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('confirmationemailstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('orderline'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscription'); // one to many reference from main entity
		$translatePartialLoader.addPart('subscriptiontype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('subscriptionstatus'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/booking/booking-dialog.html';

		return {
			/* new state for entity booking */
			/* to access: ui-ref="booking.list.new" */
			/* url: hostname/booking/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase
				referredBy: null, // will be populated once this new state is triggered from another new state with + button
				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				'HistoryService',
				function($stateParams, $state, $uibModal, $rootScope, HistoryService) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'BookingDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'BookingFactory',
									'NewBookingFactory',
									function(BookingFactory, NewBookingFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new Booking
										// - resuming the creation of a new new Booking AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return BookingFactory.get({ id: $stateParams.bookingId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewBookingFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function(result) {
							// process success result, if necessary
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// set relation as reference in the referredBy data model
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = result;
							}
						})
						.catch(function(closeReason) {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								// reset relation in referred data model object
								$stateParams.referredBy.data[$stateParams.referredBy.refName] = null;
							}
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if ($rootScope.isDefinedAndNotNull($stateParams.referredBy)) {
								HistoryService.updateHistoryParamsData($stateParams.referredBy.data, $stateParams.referredBy.refName);
							}

							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for booking new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for booking edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('booking', {
		/* abstract state for entity booking */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/booking',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'Bookings',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('booking.list', {
		/* list state for entity booking */
		/* to access: ui-ref="booking.list" */
		/* url: hostname/booking/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/booking/bookings.html',
				controller: 'BookingController',
			},
		},
	});

	$stateProvider.state('booking.detail', {
		/* detail state for entity booking */
		/* to access: ui-sref="booking.detail" */
		/* url: hostname/booking/detail/:bookingId */
		url: '/detail/:bookingId',
		views: {
			'content@': {
				templateUrl: 'app/entities/booking/booking-detail.html',
				controller: 'BookingDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'BookingFactory',
				function($stateParams, BookingFactory) {
					return BookingFactory.get({ id: $stateParams.bookingId });
				},
			],
		},
	});

	/* url: http://<hostname>/booking/list/new */
	$stateProvider.state('booking.list.new', getNewState());
	/* url: http://<hostname>/booking/list/:bookingId/edit */
	$stateProvider.state('booking.list.edit', getEditState('/:bookingId/edit'));
	/* url: http://<hostname>/booking/detail/:bookingId/edit */
	$stateProvider.state('booking.detail.edit', getEditState('/edit'));
	// Relation.booking with multiplicity 0..n points to Booking
	/* url: http://<hostname>/relation/detail/:relationId/booking/new */
	$stateProvider.state('relation.detail.newBooking', getNewState('/booking/new'));
	/* url: http://<hostname>/relation/detail/:relationId/booking/:bookingId/edit */
	$stateProvider.state('relation.detail.editBooking', getEditState('/booking/:bookingId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/booking/new */
	$stateProvider.state('user-relation.detail.newBooking', getNewState('/booking/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/booking/:bookingId/edit */
	$stateProvider.state('user-relation.detail.editBooking', getEditState('/booking/:bookingId/edit'));
	// Event.booking with multiplicity 0..n points to Booking
	/* url: http://<hostname>/event/detail/:eventId/booking/new */
	$stateProvider.state('event.detail.newBooking', getNewState('/booking/new'));
	/* url: http://<hostname>/event/detail/:eventId/booking/:bookingId/edit */
	$stateProvider.state('event.detail.editBooking', getEditState('/booking/:bookingId/edit'));

	$stateProvider.state('subscription.list.newBooking', getNewState('/booking/new'));
	$stateProvider.state('orderline.list.newBooking', getNewState('/booking/new'));

	$stateProvider.state('event.detail.subscriptions.newBooking', getNewState('/booking/new'));
	$stateProvider.state('event.detail.subscriptions.editBooking', getEditState('/booking/:bookingId/edit'));
});
